module.exports = __webpack_public_path__ + "static/media/jan_mrochen.4389914a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/jan_mrochen.jpg
// module id = 436
// module chunks = 0